import { BaseDTO } from './basedto';
import {ProposalPackageLevelDunnageType} from './ProposalPackageLevelDunnageType';

export class ProposalPackageLevel extends BaseDTO {
    ProposalId: number;
    PackageLevelId: number;
    PackagelevelTemplateId: number;
    TeslaEquipmentCode: string;
    Length: number;
    Width: number;
    Height: number;
    ODLength: number;
    ODWidth: number;
    ODHeight: number;
    IDLength: number | null;
    IDWidth: number | null;
    IDHeight: number | null;
    CollapsedHeight: number | null;
    ContainersPerLayer: number | null;
    TareWeight: number | null;
    BoxDesign: string;
    ColorCode: string;
    MaxWeight: string;
    BurstStrength: string;
    FluteSize: string;
    ReturnRatio: string;
    PackageMaterialId: number;
    IsDunnageRequired: boolean;
    IsInnerPack: boolean;
    IsShippable: boolean;
    DunnageType: string;
    proposalPackageLevelDunnageTypes: ProposalPackageLevelDunnageType[] = [];
    PackageMaterialDescription: string;
    PackageMaterialIsShippable: boolean;
    QPC: number;
    NoOfLayers: number;
    UOMSystemId: number;

    constructor() {
        super();
    }
}
